// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"57dbe81a","291":"05f51499","295":"ac95dcc8","831":"ac95dcc8"}[chunkId] + ".chunk.css";
};